/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubmissionSummaryFilter } from '../../models/submission-summary-filter';
import { SubmissionSummaryResult } from '../../models/submission-summary-result';

export interface DashboardGetSubmissionSummariesPost$Params {
      body?: SubmissionSummaryFilter
}

export function dashboardGetSubmissionSummariesPost(http: HttpClient, rootUrl: string, params?: DashboardGetSubmissionSummariesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SubmissionSummaryResult>> {
  const rb = new RequestBuilder(rootUrl, dashboardGetSubmissionSummariesPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubmissionSummaryResult>;
    })
  );
}

dashboardGetSubmissionSummariesPost.PATH = '/Dashboard/GetSubmissionSummaries';
